export type SubModuleProps = {
  __typename: string,
  contentful_id: string,
  id: string,
  moduleName: string,
  tableContentAlternative: {
    content: string[][],
    group: string,
  }
}
export const alterContainerTable = (submodule: SubModuleProps): SubModuleProps => {
  switch (submodule.contentful_id) {
    case '6sclTv1XIdoCu2Dmvt8JYh':// Custom Metrics & Reporting (public)
    case '1wllPXD19c9kvT1NqA9wqX':// Custom Metrics & Reporting (development)
      submodule.tableContentAlternative.content[6][0] = 'Target Stakeholders';
      break;
    case '54qvE1fILN9XjWPDxTIRAy':// Continuous Monitoring (public)
    case '62C6sgLdGnXGSX8arCIKCh':// Continuous Monitoring (development)
      submodule.tableContentAlternative.content = submodule.tableContentAlternative.content.filter((row) => row[0] !== 'Media');
      const existsCampaignImpact = submodule.tableContentAlternative.content.map((row) => row[0]).includes('Campaign Impact');
      !existsCampaignImpact && submodule.tableContentAlternative.content.push([
        'Campaign Impact',
        '-',// Intro
        '-',// Activation
        'Up to 8',// Acceleration
        'Up to 8',// Expansion
        'Quality the influence of each campaign dollar, optimizing resources for stronger brand perception and achieving reputational goals seamlessly integrated within RepTrak platform',
      ]);
      const existsBusinessOutcomes = submodule.tableContentAlternative.content.map((row) => row[0]).includes('Business Outcomes');
      !existsBusinessOutcomes && submodule.tableContentAlternative.content.push([
        'Business Outcomes',
        'Basic',// Intro
        'Basic',// Activation
        'Premium',// Acceleration
        'Premium',// Expansion
        'Uncover stakeholder support and engagement insights, revealing the dynamic relationship between these sentiments and your corporate reputation',
      ]);
      break;
  }
  return submodule;
}